 

function filterVariant(variant){

    let option1=variant.option1;
  $('.media-swiper-container .swiper-wrapper .product__media-item-image').remove();
  $('.thumbnail-swiper-container .swiper-wrapper .thumbnail-list_item--item-image').remove();
  $('.thumbnail-swiper-container .swiper-wrapper').append($(`.hidden-swiper-box .thumbnail-list__item[data-type="${option1}"]`).clone(true));
  $(`.hidden-swiper-box .thumbnail-list__item[data-type="all"]`).each(function(){
    $('.thumbnail-swiper-container .swiper-wrapper').append($(this).clone(true)); 
  }) 
  
  $('.media-swiper-container .swiper-wrapper').append($(`.hidden-swiper-box .product__media-item[data-type="${option1}"]`).clone(true));
  $('.media-swiper-container .swiper-wrapper').append($(`.hidden-swiper-box .product__media-item[data-type="all"]`).clone(true));
  $(`.hidden-swiper-box .product__media-item[data-type="all"]`).each(function(){
    $('.media-swiper-container .swiper-wrapper').append($(this).clone(true)); 
  }) 
  
        mediaSwiper.update();
      let index=$(`.product__media-list-item-${variant.featured_media.id}`).index();
      mediaSwiper.slideTo(index, 500, false);
  }
  



 
  function colorChange(type,initFirst) {
    $('.color-type-box .item').removeClass('active');
    $(`.color-type-box .item-${type}`).addClass('active');
    
    $(".type-product-form__input--swatch").insertAfter($(`.color-type-box .item-${type}`));
    $(".type-product-form__input--swatch label").hide();
    $(`.type-product-form__input--swatch input[data-type="${type}"]`).next('label').show();
    if(initFirst){
      $(`.type-product-form__input--swatch input[data-type="${type}"]:visible`).first().trigger('click');

    }
    console.log("type",type);
if(type==true){
  $('.in-stock-only-box,.color-type-box .item.item-true').removeClass("hide-item-true");
  
}else{
  $('.in-stock-only-box,.color-type-box .item.item-true').addClass("hide-item-true");
}

    $("product-info").data("colorType",type);
  }



  function changeColorVariants(variant,event,target) {

    availableText();
    function availableText() {
      let text="",showText="";
      if($(target).data("type")=="true"||$(target).data("type")==true){
      text=variant.available?"In-stock":"";
      showText=` | ${text} (${$(target).val()})`;
      
     } else{
      showText="";
     }
     $(".color-type-box .item-true .swatch-variant-name__label").text(showText);
    }
  }

  $('body').on('click',".in-stock-only-box", function() {
    $(this).toggleClass('active');
  const isActive = $(this).hasClass('active');
 
  $('.type-product-form__input--swatch input').each(function() {
    const $input = $(this);
  
    if ($input.data('available') == false&&$input.data('type') == true) {
      console.log($input,"isActive");
      $input.next('.swatch-input__label').toggle(!isActive);
    }
  });

  });
 

  $(document).ready(function(){
    colorChange(true,true);
    changeColorVariants("","",".type-product-form__input--swatch input:checked");
  })
 
 


 
  


  


  // 头部滑动
  $(document).ready(function(){
    let utilityBarHeight = $('.utility-bar').outerHeight() || 0;
    $('.shopify-section-header-sticky:not(.scrolled-past-header)').css('top', utilityBarHeight + 'px');
   
  })
